import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const DataProtection = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Data Protection', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Data Protection" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
             <section class="service-details section-space">
                   <div class="container">
                       <div class="row flex-xl-row flex-column-reverse">
                           <div class="col-xl-4">
                               <div class="sidebar sidebar-rr-sticky">
                                   <div class="sidebar__widget-service mb-30">
                                   <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                                   <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
       
                                   </div>
       
                                   <div class="sidebar__widget-contact__service text-center">
                                       <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                                       <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
       
                                       <Link to="/contact-us#" class="rr-btn">
                                           <span class="btn-wrap">
                                               <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                               <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                                           </span>
                                       </Link>
                       </div>
                               </div>
                           </div>
                           <div class="col-xl-8">
                               <div class="service-details__content">
                                   <div class="service-details__content-media mb-20">
                                       <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                                   </div>
       
                                   <div className="content-container">
                                    <h3 className="section-title">
                                        <i className="fa-solid fa-lock text-primary"></i> Data Protection
                                    </h3>

                                    <div className="document-section">
                                        <p className="document-description">
                                        Data protection in the medical device industry ensures that sensitive patient, device, and clinical data is securely handled and complies with regulations like <strong>GDPR</strong>. It prevents unauthorized access and data breaches, safeguarding the confidentiality and integrity of important information. This is essential for maintaining trust, ensuring patient safety, and meeting regulatory standards.
                                        </p>
                                    </div>

                                    <h4 className="sub-section-title">
                                        <i className="fa-solid fa-shield-halved text-success"></i> SQUARE MEDTECH Expertise in Data Protection
                                    </h4>
                                    <p className="document-description">
                                        SQUARE MEDTECH provides services and expertise in planning and conducting compliance processes with the <strong>General Data Protection Regulation (GDPR)</strong>.
                                    </p>

                                    <h4 className="sub-section-title">
                                        <i className="fa-solid fa-handshake text-secondary"></i> How SQUARE MEDTECH Can Support in Data Protection:
                                    </h4>
                                    <ul className="support-list">
                                        <li>
                                        <span><i class="fa-solid fa-check"></i></span> <strong>Biostatistics</strong>
                                        </li>
                                        <li>
                                        <span><i class="fa-solid fa-check"></i></span> <strong>General Data Management</strong>
                                        </li>
                                        <li>
                                        <span><i class="fa-solid fa-check"></i></span> <strong>General Data Protection Regulation Documentation</strong>
                                        </li>
                                        <li>
                                        <span><i class="fa-solid fa-check"></i></span> <strong>General Data Protection Regulation Design</strong>
                                        </li>
                                    </ul>
                                    </div>

                               </div>
                           </div>
                       </div>
                   </div>
               </section>
       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Data Protection Services:</h4>
                    <ul class="color-white mb-0">
                    <li>Data Protection</li>
                    <li>General Data Management</li>
                    <li>Digital Health Services & Consultations</li>
                    </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Data Protection Services:</h4>
                    <ul class="color-white mb-0">
                    <li>Data Management Consulting</li>
                    <li>Medical Software Development</li>
                    <li>General Data Protection Regulation Documentation</li>
                    </ul>


                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
